const version = '1.33.2';

const commitId = '08f9d5f2';

const buildDate = '2025-01-29T07:54:37Z';

const buildUser = 'kamer';

const meta = {
    version,
    commitId,
    buildDate,
    buildUser
};

Object.freeze(meta);
Object.seal(meta);

console.log('Grispi UI build metadata', meta);

export { meta };
